const SERVER_IP = "localhost";
const SERVER_PORT = "8000";
const TRANSPORTER_NAME = "RAJ CARRYING CARGO PVT LTD";

const USE_OVERLAY = true;

const getServerUrl = () => {
  const host = window.location.hostname;

  if (host.includes("localhost")) {
    return "https://backend.myrcc.in";
  }

  const subdomain = host.split(".")[0];

  const match = subdomain.match(/\d+$/);
  const suffix = match ? match[0] : "";

  return `https://backend.myrcc.in`;
};

const getPrintUrl = () => {
  const host = window.location.hostname;

  if (host.includes("localhost")) {
    return "https://print.myrcc.in";
  }

  const subdomain = host.split(".")[0];

  const match = subdomain.match(/\d+$/);
  const suffix = match ? match[0] : "";

  return `https://print${suffix}.myrcc.in`;
};

const getServerUrl2 = () => {
  const host = window.location.hostname;

  if (host.includes("localhost")) {
    return "https://be.myrcc.in";
  }

  const subdomain = host.split(".")[0];

  const match = subdomain.match(/\d+$/);
  const suffix = match ? match[0] : "";

  return `https://be${suffix}.myrcc.in`;
};

const getLocalFlag = () => {
  try {
    let lo = localStorage.getItem("local_flag") === 'true';
    console.log("Inansdsnns", lo);
    return lo;
  } catch (e) {
    return false;
  }
};

var SERVER_URL = "";
if (getLocalFlag()) {
  console.log("in if");
  SERVER_URL = getServerUrl2();
} else {
  console.log("in else");
  SERVER_URL = getServerUrl();
}

// SERVER_URL = "http://" + SERVER_IP + ":" + SERVER_PORT;

var NEW_PRINT = getPrintUrl();
var SERVER_URL_2 = getServerUrl2();

export {
  SERVER_URL,
  USE_OVERLAY,
  TRANSPORTER_NAME,
  SERVER_URL_2,
  NEW_PRINT
};
